import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckIcon, AlertCircleIcon, ArrowLeftIcon, LockIcon } from 'lucide-react';
const VerifyBankAccount = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [accountDetails, setAccountDetails] = useState({
    accountName: 'Acme Supplies Pty Ltd',
    bsb: '123-456',
    accountNumber: '****7890' // Masked for security
  });
  const [verificationMethod, setVerificationMethod] = useState('');
  const [lastDigits, setLastDigits] = useState('');
  const [isPennyTestInitiated, setIsPennyTestInitiated] = useState(false);
  const [pennyTestAmount, setPennyTestAmount] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const handleInitiatePennyTest = () => {
    // In a real app, this would call an API to initiate a penny test
    setIsPennyTestInitiated(true);
  };
  const handleVerifyPennyTest = () => {
    // In a real app, this would verify the penny test amount with the backend
    if (pennyTestAmount === '0.01') {
      setIsVerified(true);
    } else {
      alert('Incorrect amount. Please check your bank account and try again.');
    }
  };
  const handleVerifyLastDigits = () => {
    // In a real app, this would verify the last digits with the backend
    if (lastDigits === '7890') {
      setIsVerified(true);
    } else {
      alert('Incorrect last digits. Please check your bank account number and try again.');
    }
  };
  return <div className="space-y-6" data-id="element-214">
      <div className="flex items-center" data-id="element-215">
        <button type="button" onClick={() => navigate('/bank-accounts')} className="mr-4 text-gray-400 hover:text-gray-500" data-id="element-216">
          <ArrowLeftIcon className="h-5 w-5" data-id="element-217" />
        </button>
        <div data-id="element-218">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-219">
            Verify Bank Account
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-220">
            Verify ownership of this bank account
          </p>
        </div>
      </div>
      {/* Only show account details after verification */}
      {isVerified && <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-221">
          <div className="px-4 py-5 sm:px-6" data-id="element-222">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-223">
              Account Details
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-224">
              Your verified bank account details
            </p>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:p-0" data-id="element-225">
            <dl className="sm:divide-y sm:divide-gray-200" data-id="element-226">
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" data-id="element-227">
                <dt className="text-sm font-medium text-gray-500" data-id="element-228">
                  Account name
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" data-id="element-229">
                  {accountDetails.accountName}
                </dd>
              </div>
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" data-id="element-230">
                <dt className="text-sm font-medium text-gray-500" data-id="element-231">BSB</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" data-id="element-232">
                  {accountDetails.bsb}
                </dd>
              </div>
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" data-id="element-233">
                <dt className="text-sm font-medium text-gray-500" data-id="element-234">
                  Account number
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" data-id="element-235">
                  {accountDetails.accountNumber}
                </dd>
              </div>
            </dl>
          </div>
        </div>}
      {!isVerified && !verificationMethod && <div className="bg-white shadow sm:rounded-lg" data-id="element-236">
          <div className="px-4 py-5 sm:p-6" data-id="element-237">
            <div className="flex items-center mb-4 text-yellow-600" data-id="element-238">
              <LockIcon className="h-5 w-5 mr-2" data-id="element-239" />
              <p className="text-sm" data-id="element-240">
                Bank details are hidden until verification is complete
              </p>
            </div>
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-241">
              Choose Verification Method
            </h3>
            <div className="mt-2 max-w-xl text-sm text-gray-500" data-id="element-242">
              <p data-id="element-243">
                Select how you'd like to verify ownership of this bank account.
              </p>
            </div>
            <div className="mt-5 space-y-4" data-id="element-244">
              <div className="relative flex items-start" data-id="element-245">
                <div className="flex items-center h-5" data-id="element-246">
                  <input id="penny-test" name="verification-method" type="radio" value="penny-test" checked={verificationMethod === 'penny-test'} onChange={() => setVerificationMethod('penny-test')} className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300" data-id="element-247" />
                </div>
                <div className="ml-3 text-sm" data-id="element-248">
                  <label htmlFor="penny-test" className="font-medium text-gray-700" data-id="element-249">
                    Micro-deposit Verification
                  </label>
                  <p className="text-gray-500" data-id="element-250">
                    We'll send a small amount (less than $1) to your account.
                    Once you see it, you'll confirm the exact amount.
                  </p>
                </div>
              </div>
              <div className="relative flex items-start" data-id="element-251">
                <div className="flex items-center h-5" data-id="element-252">
                  <input id="last-digits" name="verification-method" type="radio" value="last-digits" checked={verificationMethod === 'last-digits'} onChange={() => setVerificationMethod('last-digits')} className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300" data-id="element-253" />
                </div>
                <div className="ml-3 text-sm" data-id="element-254">
                  <label htmlFor="last-digits" className="font-medium text-gray-700" data-id="element-255">
                    Confirm Account Number
                  </label>
                  <p className="text-gray-500" data-id="element-256">
                    Enter the last 4 digits of your account number to verify
                    ownership.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5" data-id="element-257">
              <button type="button" disabled={!verificationMethod} onClick={() => {
            if (verificationMethod === 'penny-test') {
              handleInitiatePennyTest();
            } else if (verificationMethod === 'last-digits') {
              // Show the last-digits verification form directly
            }
          }} className={`inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${!verificationMethod ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-258">
                Continue
              </button>
            </div>
          </div>
        </div>}
      {verificationMethod === 'penny-test' && isPennyTestInitiated && !isVerified && <div className="bg-white shadow sm:rounded-lg" data-id="element-259">
            <div className="px-4 py-5 sm:p-6" data-id="element-260">
              <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-261">
                Micro-deposit Verification
              </h3>
              <div className="mt-2 max-w-xl text-sm text-gray-500" data-id="element-262">
                <p data-id="element-263">
                  We've sent a small deposit to your bank account. This may take
                  1-2 business days to appear. Once you see it, enter the exact
                  amount below.
                </p>
              </div>
              <div className="mt-5 sm:flex sm:items-center" data-id="element-264">
                <div className="w-full sm:max-w-xs" data-id="element-265">
                  <label htmlFor="amount" className="sr-only" data-id="element-266">
                    Deposit Amount
                  </label>
                  <div className="mt-1 relative rounded-md shadow-sm" data-id="element-267">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-268">
                      <span className="text-gray-500 sm:text-sm" data-id="element-269">$</span>
                    </div>
                    <input type="text" name="amount" id="amount" value={pennyTestAmount} onChange={e => setPennyTestAmount(e.target.value)} className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" data-id="element-270" />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-271">
                      <span className="text-gray-500 sm:text-sm" data-id="element-272">USD</span>
                    </div>
                  </div>
                </div>
                <button type="button" onClick={handleVerifyPennyTest} className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-273">
                  Verify
                </button>
              </div>
            </div>
          </div>}
      {verificationMethod === 'last-digits' && !isVerified && <div className="bg-white shadow sm:rounded-lg" data-id="element-274">
          <div className="px-4 py-5 sm:p-6" data-id="element-275">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-276">
              Confirm Account Number
            </h3>
            <div className="mt-2 max-w-xl text-sm text-gray-500" data-id="element-277">
              <p data-id="element-278">
                Enter the last 4 digits of your bank account number to verify
                ownership.
              </p>
            </div>
            <div className="mt-5 sm:flex sm:items-center" data-id="element-279">
              <div className="w-full sm:max-w-xs" data-id="element-280">
                <label htmlFor="last-digits" className="sr-only" data-id="element-281">
                  Last 4 Digits
                </label>
                <input type="text" name="last-digits" id="last-digits" value={lastDigits} onChange={e => setLastDigits(e.target.value)} maxLength={4} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Last 4 digits" data-id="element-282" />
              </div>
              <button type="button" onClick={handleVerifyLastDigits} className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-283">
                Verify
              </button>
            </div>
          </div>
        </div>}
      {isVerified && <div className="rounded-md bg-green-50 p-4" data-id="element-284">
          <div className="flex" data-id="element-285">
            <div className="flex-shrink-0" data-id="element-286">
              <CheckIcon className="h-5 w-5 text-green-400" data-id="element-287" />
            </div>
            <div className="ml-3" data-id="element-288">
              <h3 className="text-sm font-medium text-green-800" data-id="element-289">
                Bank account verified
              </h3>
              <div className="mt-2 text-sm text-green-700" data-id="element-290">
                <p data-id="element-291">
                  Your bank account has been successfully verified and is ready
                  to receive payments.
                </p>
              </div>
              <div className="mt-4" data-id="element-292">
                <div className="-mx-2 -my-1.5 flex" data-id="element-293">
                  <button type="button" onClick={() => navigate('/bank-accounts')} className="bg-green-50 px-2 py-1.5 rounded-md text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600" data-id="element-294">
                    Return to Bank Accounts
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
export default VerifyBankAccount;